/** 用户性别 */
export enum UserGender {
  /** 男 */
  MALE = 'MALE',
  /** 女 */
  FEMALE = 'FEMALE',
  /** 未知 */
  UNKNOWN = 'UNKNOWN',
}

/** 注册渠道 */
export enum RegisterChannel {
  /** 大健康app */
  HEALTH_APP = 'HEALTH_APP',
  /** 共比邻小程序 */
  BE_LINK_MINI_PROGRAM = 'BE_LINK_MINI_PROGRAM',
  /** 微信网页授权 */
  WECHAT_WEB_AUTH = 'WECHAT_WEB_AUTH',
}

/** 用户状态 */
export enum UserStatus {
  /** 有效 */
  VALID = 'VALID',
  /** 禁言 */
  SILENCED = 'SILENCED',
  /** 封禁 */
  BLOCKED = 'BLOCKED',
}

/** 会员等级 */
export enum UserLevel {
  /** 注册会员 */
  REGISTERED = 'REGISTERED',
  /** 高级会员 */
  ADVANCED = 'ADVANCED',
  /** 尊贵会员 */
  HONORED = 'HONORED',
  /** 黄金会员 */
  GOLD = 'GOLD',
  /** 钻石会员 */
  DIAMOND = 'DIAMOND',
  /** 黑钻会员 */
  BLACK_DIAMOND = 'BLACK_DIAMOND',
}

/** 不能观看直播的原因类型 */
export enum CannotWatchReasonType {
  /** 用户不存在 */
  USER_NOT_EXISTS = 'USER_NOT_EXISTS',
  /** 直播间未绑定该门店 */
  ROOM_NOT_BOUND_TO_STORE = 'ROOM_NOT_BOUND_TO_STORE',
  /** 直播已结束 */
  LIVE_ENDED = 'LIVE_ENDED',
  /** 直播功能迁移至新小程序 */
  LIVE_MIGRATED = 'LIVE_MIGRATED',
  /** 用户账号被后台拉黑 */
  USER_BLOCKED = 'USER_BLOCKED',
  /** 门店打烊 */
  STORE_CLOSED = 'STORE_CLOSED',
}

export enum CannotWatchReasonTypeIcon {
  ROOM_NOT_BOUND_TO_STORE = 'jp_zwkf%402x.png',
  LIVE_ENDED = 'jp_zbjs%402x.png',
  LIVE_MIGRATED = 'jp_gkzb%402x.png',
  USER_BLOCKED = 'jp_wjy%402x.png',
  STORE_CLOSED = 'jp_mdzzhz%402x.png',
}

export enum STORE_BUSINESS_STATUS {
  /** 未开页 */
  UNBOUND_MANAGER = 'UNBOUND_MANAGER',
  /** 营业中 */
  OPERATING = 'OPERATING',
  /** 已打烊 */
  CLOSED = 'CLOSED',
}
